import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "store/actions";
import { State } from "store/reducers";
import { BankBilletDetailState } from "store/reducers/bankBillet/detail";
import Report from "Components/Report";
import ls from "Localization";
import ISplit from "Types/Split";
import { toStringCurrency } from "helpers/string";
import CreateSplit from "./Create";

function Splits({ id }: any) {
	const dispatch = useDispatch<any>();

	useEffect(() => {
		dispatch(actions.bankBillet.detail.getSplits(id));
	}, [dispatch, id]);

	const { splits, loading } = useSelector<State, BankBilletDetailState>(
		s => s.bankBilletDetail
	);

	return (
		<Report
			titleText="Splits"
			title="Splits"
			data={splits}
			headerRightComponent={<CreateSplit />}
			loading={loading.split}
			columns={[
				{
					Header: ls.name,
					id: "name",
					show: true,
					accessor: (c: ISplit) =>
						c.user ? `${c.user.name} - ${c.user.lastname}` : c.document || ""
				},
				{
					Header: ls.value,
					id: "value",
					show: true,
					filterable: false,
					accessor: (c: ISplit) => {
						if (c.value !== undefined && !isNaN(c.value)) {
							return toStringCurrency(+c.value / 100.0);
						}
						return "Valor inválido";
					},
					width: 150
				}
			]}
			filterable={false}
			getTdProps={() => {
				return {
					style: {
						display: "flex",
						alignItems: "center"
					}
				};
			}}
		/>
	);
}

export default Splits;
